import Sidebar from "./sidebar";
import Header from "./header";
import Footer from "./footer";
import { RWebShare } from "react-web-share";
import "./style.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { requestAdminAllQuestion, requestAdminAddQuestion, requestAdminGetQuestion, requestAdminEditQuestion, requestAdminDeleteQuestion, requestAdminAllQuestionOptions } from "../Redux/actions";
import image from "../images/extraLogo.png";
import Swal from "sweetalert2";
import axios from 'axios';

function Question(props) {
  const location = useLocation();
  const params = useParams();
  const [question, setquestion] = useState([]);
  const [questionoptions, setquestionoptions] = useState([]);
  const [pagination, setpagination] = useState({});
  const navigate = useNavigate();
  const [change, setchange] = useState(false);
  const [pages, setpages] = useState([]);
  const [page_size, setpage_size] = useState(0);
  const addtoggle = () => setaddModal(!addmodal);
  const [addmodal, setaddModal] = useState(false);
  const [editmodal, seteditModal] = useState(false);
  const [optionmodal, setoptionModal] = useState(false);

  const [error, seterror] = useState("");
  const [errorTags, seterrorTags] = useState("");
  const [errorRole, seterrorRole] = useState("");
  const [errorExperience, seterrorExperience] = useState("");
  const [errorType, seterrorType] = useState("");

  const [id, setid] = useState(0);
  const [adddata, setadddata] = useState({
    name: "",
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    option5: "",
    option6: "",

  });
  const [editdata, seteditdata] = useState({
    name: "",
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    option5: "",
    option6: "",

  });
  const [fun_areas, setfun_areas] = useState([]);
  const [job_title, setjob_title] = useState(location.state.job_title);

  useEffect(() => {
    let funAreaData = props.data.loginData.data.data.fun_area;
    if (funAreaData !== undefined) {
      setfun_areas(funAreaData);
    }
  }, [props.data.loginData.data.data]);

  function validateadd() {
    let formIsValid = false;
    if (!adddata["name"]) {
      formIsValid = false;
      seterror("*Enter question.");
    } else if (typeof adddata["name"] !== "undefined") {
        formIsValid = true;
        seterror("");
    }    
    return formIsValid;    
  }

  function typeadd() {
    let formIsValid = false;
    if (adddata["type"] === "0") {
      formIsValid = false;
      seterrorType("*Select question type.");
    } else if (typeof adddata["type"] === "undefined") {
      formIsValid = false;
      seterrorType("*Select question type.");
    } else {
      formIsValid = true;
      seterrorType("");
    }
    return formIsValid;
  }

  function validateAddForm() {      
    let validate = validateadd(); let type = typeadd();
    let valid = validate && type;
    return valid;
  }

  //edit form
  function validateedit() {
    let formIsValid = false;
    if (!editdata["name"]) {
      formIsValid = false;
      seterror("*Enter question name.");
    } else if (typeof editdata["name"] !== "undefined") {      
        formIsValid = true;
        seterror("");
    }
    return formIsValid;
  }

  function typeedit() {
    let formIsValid = false;
    if (editdata["type"] === "0") {
      formIsValid = false;
      seterrorType("*Select question type.");
    } else if (typeof editdata["type"] === "undefined") {
      formIsValid = false;
      seterrorType("*Select question type.");
    } else {
      formIsValid = true;
      seterrorType("");
    }
    return formIsValid;
  }

  function validateEditForm() {
    let validate = validateedit(); let type = typeedit();
    let valid = validate && type;
    return valid;
  }

  function onchangeadddata(e) {
    setadddata((adddata) => ({
      ...adddata,
      [e.target.name]: e.target.value,
    }));
  }
  
  function onchangeeditdata(e) {
    seteditdata((editdata) => ({
      ...editdata,
      [e.target.name]: e.target.value,
    }));
  }

  //save question
  const saveaddtoggle = (e) => {
    e.preventDefault();
    if (validateAddForm()) {
      props.requestAdminAddQuestion({
        data: {
          user_id: 1,
          job_id: params.id,
          name: adddata.name,
          type: adddata.type,
          option1: adddata.option1,
          option2: adddata.option2,
          option3: adddata.option3,
          option4: adddata.option4,
          option5: adddata.option5,
          option6: adddata.option6,
        },
      });
      setadddata({
        name: "",
        option1: "",
        option2: "",
        option3: "",
        option4: "",
        option5: "",
        option6: "",
      });
      addtoggle();
    }
  };

  //save question response
  useEffect(() => {
    let addQuestionData = props.data.addQuestionData;
    if (addQuestionData !== undefined) {
      if (addQuestionData?.data?.status == "success") {
        Swal.fire(
          "Good job!",
          "Question Added Successfully.",
          "success"
        );
        props.data.addQuestionData = undefined;
        setadddata({
          name: "",
          type: 0,
        });        
        addtoggle();
        setchange(!change);
      } else {
        Swal.fire("Error!", `${addQuestionData.data.message}`, "error");
        props.data.addQuestionData = undefined;
      }
    }
  }, [props.data.addQuestionData]);

  // set edit
  const edittoggle = (id) => {
    if (editmodal === true) {
      seteditModal(!editmodal);
    } else {
      seteditModal(!editmodal);
      setid(id);
      seteditdata({
        name: " ",
        type: 0,
        option1: " ",
        option2: " ",
        option3: " ",
        option4: " ",
        option5: " ",
        option6: " ",
      });
      props.requestAdminGetQuestion({
        id: id,
      });
      // props.requestAdminAllQuestionOptions({
      //   id: id,
      // });
      // setquestionoptions(props.data.allQuestionOptionsData);
    }
  };

  useEffect(() => {
    let question = props.data.getQuestionData;
    if (question !== undefined) {
      if (question.data) {
        console.log('question.data.data.Company[0]');
        console.log(question.data.data.Question[0]);
        seteditdata(question.data.data.Question[0]);
      }
    }
  }, [props.data.getQuestionData]);

  //set options
  const optiontoggle = (id) => {
    if (optionmodal === true) {
      setoptionModal(!optionmodal);
    } else {
      setoptionModal(!optionmodal);
      // setid(id);
      props.requestAdminAllQuestionOptions({
        id: id,
      });
      setquestionoptions(props.data.data.allQuestionOptionsData);
    }
  };

  //get options
  useEffect(() => {
    let questionoptions = props.data.allQuestionOptionsData;
    if (questionoptions !== undefined) {
      if (questionoptions) {
        setquestionoptions(questionoptions);
      }
    }
  }, [props.data.allQuestionOptionsData]);


  const saveedittoggle = (e) => {
    e.preventDefault();
    if (validateEditForm()) {
      props.requestAdminEditQuestion({
        id: id,
        data: {
          job_id: params.id,
          name: editdata.name,
          type: editdata.type,
          option1: editdata.option1,
          option2: editdata.option2,
          option3: editdata.option3,
          option4: editdata.option4,
          option5: editdata.option5,
          option6: editdata.option6,
        },
      });
      seteditdata({
        name: "",
        type: 0,
        option1: "",
        option2: "",
        option3: "",
        option4: "",
        option5: "",
        option6: "",
      });
      setid(0);
      edittoggle();
    }
  };

  //update response
  useEffect(() => {
    let editQuestionData = props.data.editQuestionData;
    if (editQuestionData !== undefined) {
      if (editQuestionData?.data?.status == "success") {
        Swal.fire(
          "Good job!",
          "Question Updated Successfully.",
          "success"
        );
        props.data.editQuestionData = undefined;
        seteditdata({
          name: "",
          type: 0,
        });
        edittoggle();
        setchange(!change);
      } else {
        Swal.fire("Error!", `${editQuestionData.data.message}`, "error");
        props.data.editQuestionData = undefined;
      }
    }
  }, [props.data.editQuestionData]);

  //list
  useEffect(() => {
    props.requestAdminAllQuestion({
      id: params.id
    });
    setpage_size(params.page_size);
  }, [params.page, params.page_size, change]);

  function onChangePageSize(e) {
    setpage_size(e.target.value);
    if (e.target.value > 0) {
      navigate(`/admin/question/1/${e.target.value}`);
    }
  }

  //list without pagination
  useEffect(() => {
    let questionData = props.data.allQuestionData;
    console.log(questionData);
    if (questionData !== undefined) {
      if (questionData) {
        setquestion(questionData);
      }
    }
  }, [props.data.allQuestionData]);

  function deletedata(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        props.requestAdminDeleteQuestion({
          id: id,
        });
      }
    })
  }

  //delete
  useEffect(() => {
    let deleteQuestionData = props.data.deleteQuestionData;
    if (deleteQuestionData !== undefined) {
      if (deleteQuestionData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Comapny name deleted successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.deleteQuestionData = undefined;
  }, [props.data.deleteQuestionData]);

  function printPage() {
    var printContents =
      "<br/><center><h3>Question</h3></center>" +
      document.getElementById("printme").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  return (
    <>
      <div class="container-scroller">
        <Header name={'Questions for ' + job_title} />
        <div class="container-fluid page-body-wrapper">
          <Sidebar name="Question" />

          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-sm-12">
                  <div class="home-tab">
                    <div class="row flex-grow">
                      <div class="col-12 grid-margin stretch-card">
                        <div class="card card-rounded">
                          <div class="card-body">
                            <div class="d-sm-flex justify-content-between align-items-start">
                              <div class="btn-wrapper">
                                <RWebShare
                                  data={{
                                    text: "Job Portal",
                                    url: `http://localhost:3000/admin/question/${params.page}/${params.page_size}`,
                                    title: "Job Portal",
                                  }}
                                >
                                  <p class="btn btn-otline-dark align-items-center">
                                    <i class="icon-share"></i> Share
                                  </p>
                                </RWebShare>
                                <button
                                  onClick={printPage}
                                  class="btn btn-otline-dark"
                                >
                                  <i class="icon-printer"></i> Print
                                </button>
                              </div>
                              <div>
                                <button
                                  class="btn btn-primary btn-md text-white mb-0 me-0"
                                  type="button"
                                  onClick={addtoggle}
                                >
                                  Add new Question
                                </button>
                                <Modal isOpen={addmodal} toggle={addtoggle}>
                                  <ModalHeader toggle={addtoggle}>
                                    Add Question
                                  </ModalHeader>
                                  <ModalBody>
                                    <form class="forms-sample">
                                    <div class="row">
                                    <label>Name</label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          placeholder="Name"
                                          name="name"
                                          value={adddata.name}
                                          onBlur={validateadd}
                                          onChange={onchangeadddata}
                                        />
                                        {error && <p>{error}</p>}
                                        <label>
                                          <br />
                                          Question Type
                                        </label>
                                        <select
                                          class="form-select"
                                          name="type"
                                          value={adddata.type}
                                          onBlur={typeadd}
                                          onChange={onchangeadddata}>
                                          <option value="0">Select Type</option>
                                          <option value="1">Short</option>
                                          <option value="2">Long</option>
                                          <option value="3">Single Options</option>
                                          <option value="4">Multiple Select</option>
                                        </select>
                                        {errorType && <p>{errorType}</p>}
                                        <label> <br /> Option 1 </label>
                                        <input type="text" name="option1" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                          value={adddata.option1} onChange={onchangeadddata} />

                                        <label> <br /> Option 2 </label>
                                        <input type="text" name="option2" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                          value={adddata.option2} onChange={onchangeadddata} />

                                        <label> <br /> Option 3 </label>
                                        <input type="text" name="option3" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                          value={adddata.option3} onChange={onchangeadddata} />

                                        <label> <br /> Option 4 </label>
                                        <input type="text" name="option4" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                          value={adddata.option4} onChange={onchangeadddata} />
                                          
                                        <label> <br /> Option 5 </label>
                                        <input type="text" name="option5" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                          value={adddata.option5} onChange={onchangeadddata} />
                                          
                                        <label> <br /> Option 6 </label>
                                        <input type="text" name="option6" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                          value={adddata.option6} onChange={onchangeadddata} />
                                    </div>
                                      <button
                                        type="submit"
                                        class="btn btn-primary me-2"
                                        onClick={saveaddtoggle}
                                      >
                                        Submit
                                      </button>
                                      <button
                                        class="btn btn-light"
                                        onClick={addtoggle}
                                      >
                                        Cancel
                                      </button>
                                    </form>
                                  </ModalBody>
                                </Modal>
                              </div>
                            </div>
                            <br />
                            <div class="table-responsive  mt-1" id="printme">
                              <table class="table select-table">
                                <thead>
                                  <tr >
                                    <th>Question</th>
                                    <th>Type</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                {question.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <div class="d-flex ">
                                            <div>
                                              <h6>{item.name}</h6>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          {item.type == 1 ? <p>Short</p> : item.type == 2 ? <p>Long</p> : item.type == 3 ? <p>Options</p> : <p>Multi Selection</p>}                                          
                                        </td>
{/*                                        <td>
                                         <button
                                            class="badge badge-opacity-warning"
                                            style={{
                                              border: "0px",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => {
                                              optiontoggle(item.id);
                                            }}
                                          >
                                            {item.count}
                                          </button>
                                          {optionmodal === true && (
                                            <Modal
                                              isOpen={optionmodal}
                                              toggle={optiontoggle}
                                            >
                                              <ModalHeader toggle={optiontoggle}>
                                                Question Options
                                              </ModalHeader>
                                              <ModalBody>
                                              <div class="table-responsive  mt-1" id="printme">
                                                <table class="table select-table">
                                                  <thead>
                                                    <tr >
                                                    <th>Options</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                  {questionoptions.map((item, index) => {
                                                      return (
                                                        <tr key={index}>
                                                          <td>
                                                            <div class="d-flex ">
                                                              <div>
                                                                <h6>{item.q_option}</h6>
                                                              </div>
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      );
                                                    })}
                                                  </tbody>
                                                </table>
                                              </div>
                                              </ModalBody>
                                            </Modal>
                                          )} 
                                        </td> */}
                                        <td>
                                          <p>{item.created_at.substring(0, 10)}</p>
                                        </td>
                                        <td>
                                          <p>{item.updated_at.substring(0, 10)}</p>
                                        </td>
                                        <td>
                                          <button
                                            class="badge badge-opacity-success"
                                            style={{
                                              border: "0px",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => {
                                              edittoggle(item.id);
                                            }}
                                          >
                                            <i class="fa fa-pencil-square-o"></i>
                                          </button>
                                          {editmodal === true && (
                                            <Modal
                                              isOpen={editmodal}
                                              toggle={edittoggle}
                                            >
                                              <ModalHeader toggle={edittoggle}>
                                                Edit Question
                                              </ModalHeader>
                                              <ModalBody>
                                                <form class="forms-sample">
                                                  <div class="form-group">
                                                    <label>Name</label>
                                                    <input
                                                      type="text"
                                                      class="form-control"
                                                      placeholder="Name"
                                                      name="name"
                                                      value={editdata.name}
                                                      onBlur={validateedit}
                                                      onChange={onchangeeditdata}
                                                    />
                                                    {error && <p>{error}</p>}
                                                    <label> <br /> Question Type </label>
                                                    <select
                                                      class="form-select" name="type" value={editdata.type} onChange={onchangeeditdata} onBlur={typeedit}>
                                                      <option value="0">Select Type</option> <option value="1">Short</option>
                                                      <option value="2">Long</option> <option value="3">Single Options</option>
                                                      <option value="4">Multiple Select</option>
                                                    </select>
                                                    {errorType && <p>{errorType}</p>}

                                                    <label> <br /> Option 1 </label>
                                                    <input 
                                                    type="text" name="option1" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                                      value={editdata.option1} onChange={onchangeeditdata} />
                                                      
                                                    <label> <br /> Option 2 </label>
                                                    <input type="text" name="option2" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                                      value={editdata.option2} onChange={onchangeeditdata} />
                                                    
                                                    <label> <br /> Option 3 </label>
                                                    <input type="text" name="option3" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                                      value={editdata.option3} onChange={onchangeeditdata} />

                                                    <label> <br /> Option 4 </label>
                                                    <input type="text" name="option4" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                                      value={editdata.option4} onChange={onchangeeditdata} />
                                                      
                                                    <label> <br /> Option 5 </label>
                                                    <input type="text" name="option5" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                                      value={editdata.option5} onChange={onchangeeditdata} />
                                                      
                                                    <label> <br /> Option 6 </label>
                                                    <input type="text" name="option6" class="form-control" placeholder="Enter the Option or Keep it Blank."
                                                      value={editdata.option6} onChange={onchangeeditdata} />
                                                  </div>

                                                  <button
                                                    type="submit"
                                                    class="btn btn-primary me-2"
                                                    onClick={saveedittoggle}
                                                  >
                                                    Submit
                                                  </button>
                                                  <button
                                                    class="btn btn-light"
                                                    onClick={edittoggle}
                                                  >
                                                    Cancel
                                                  </button>
                                                </form>
                                              </ModalBody>
                                            </Modal>
                                          )}
                                          <button
                                            class="badge badge-opacity-danger"
                                            style={{
                                              border: "0px",
                                              background: "#fea8a9",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => {

                                              deletedata(item.id);

                                            }}
                                          >
                                            <i class="fa fa-trash"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>

                            <div class="row">
                              <div class="col-10">
                                <div class="pagination center">
                                  <ul class="pagination-list">
                                    {pagination.current_page !== 1 && (
                                      <li>
                                        <a
                                          href={`/admin/question/${params.page - 1
                                            }/${params.page_size}`}
                                        >
                                          <i class="fa fa-long-arrow-left"></i>
                                        </a>
                                      </li>
                                    )}
                                    {pages.map((i) => {
                                      return pagination.current_page === i ? (
                                        <li class="active">
                                          <a
                                            href={`/admin/question/${i}/${params.page_size}`}
                                          >
                                            {i}
                                          </a>
                                        </li>
                                      ) : (
                                        <li>
                                          <a
                                            href={`/admin/question/${i}/${params.page_size}`}
                                          >
                                            {i}
                                          </a>
                                        </li>
                                      );
                                    })}
                                    {pagination.current_page !==
                                      pagination.last_page && (
                                        <li>
                                          <a
                                            href={`/admin/question/${Number(params.page) + 1
                                              }/${params.page_size}`}
                                          >
                                            <i class="fa fa-long-arrow-right"></i>
                                          </a>
                                        </li>
                                      )}
                                  </ul>
                                </div>
                              </div>
                              <div class="col-2">
                                <div class="pagination center">
                                  <form onSubmit={onChangePageSize}>
                                    <div class="form-group">
                                      <input
                                        type="number"
                                        class="form-control"
                                        placeholder={page_size}
                                        name="page_size"
                                        value={page_size}
                                        onChange={onChangePageSize}
                                        style={{ width: "100px" }}
                                      />
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ 
    requestAdminAllQuestion, requestAdminAddQuestion, requestAdminGetQuestion, requestAdminEditQuestion, requestAdminDeleteQuestion, requestAdminAllQuestionOptions}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Question);
